import React, { useEffect } from "react";
import { Fingerprint, LogOut } from "lucide-react";

// Pantalla de bloqueo a pantalla completa — se muestra por encima de
// todo (incluso por encima de los modales de edición) mientras la app
// está bloqueada. En cuanto aparece, pide la huella/Face ID sola, sin
// que haga falta tocar nada primero — así se entra directamente con la
// biometría, como en una app bancaria. El botón "Desbloquear" se deja
// como respaldo visible por si el navegador bloquea ese primer intento
// automático (algunos exigen que la petición venga de un toque directo
// del usuario) o si la verificación falla y hay que reintentar.
export default function LockScreen({ lang, verifying, lastError, onUnlock, onLogout }) {
  useEffect(() => {
    // Evita hacer scroll del contenido de detrás mientras está bloqueado
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  useEffect(() => {
    // Se pide una sola vez, justo al aparecer esta pantalla. Si el
    // navegador la bloquea por falta de un toque del usuario, no pasa
    // nada visible — simplemente se queda el botón para tocarlo a mano.
    onUnlock();
  }, [onUnlock]);

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 999,
      background: "var(--card)",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      gap: 20, padding: 24, textAlign: "center",
    }}>
      <div style={{
        width: 88, height: 88, borderRadius: "50%",
        background: "var(--blue-l)", display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Fingerprint size={44} style={{ color: "var(--blue)" }} />
      </div>

      <div>
        <div style={{ fontSize: 17, fontWeight: 700, color: "var(--gray-800)", marginBottom: 4 }}>
          {lang === "en" ? "ARIA Wallet is locked" : "ARIA Wallet está bloqueada"}
        </div>
        <div style={{ fontSize: 13, color: "var(--gray-500)" }}>
          {lang === "en" ? "Use Face ID / fingerprint to continue" : "Usa Face ID / huella para continuar"}
        </div>
      </div>

      {lastError && (
        <div style={{ fontSize: 12, color: "var(--red)", maxWidth: 280 }}>
          {lang === "en" ? "Couldn't verify — try again." : "No se pudo verificar — inténtalo otra vez."}
        </div>
      )}

      <button type="button" onClick={onUnlock} disabled={verifying}
        className="btn btn-primary"
        style={{ padding: "12px 28px", fontSize: 15, display: "flex", alignItems: "center", gap: 8 }}>
        <Fingerprint size={18} />
        {verifying
          ? (lang === "en" ? "Verifying..." : "Verificando...")
          : (lang === "en" ? "Unlock" : "Desbloquear")}
      </button>

      <button type="button" onClick={onLogout}
        style={{ background: "none", border: "none", cursor: "pointer", color: "var(--gray-400)",
                 fontSize: 13, display: "flex", alignItems: "center", gap: 5, marginTop: 8 }}>
        <LogOut size={14} />
        {lang === "en" ? "Log out instead" : "Cerrar sesión en su lugar"}
      </button>
    </div>
  );
}
